<template>
  <TemplateBackground>
    <template v-slot:label>
      Solicitar recuperação de conta
    </template>

    <template v-slot:content>
      <div class="mt-2">
        <Input
          name="input-recovery-email"
          placeholder="Email de cadastro"
          type="email"
          :value="formData.email"
          :on-change="(value) => formData.email = value"
          validate-with-on-blur
          :validate="value => useValidations('email', value)"
          :on-validate="(value) => formDataValidate.email = value"
          :helper-text="'E-mail inválido.'"
          :helper-text-class="'text-white bg-orange-400 p-1 rounded-md'"
          block-copy
          :validate-on-update="isValideAll"
        />
      </div>

      <Message v-if="!statusResponse" class="mt-10" type="warn">
        Verifique sua conexão e tente novamente.
      </Message>

      <p v-else-if="statusResponse === 200" class="mt-10 text-white -text-lg bg-green-600 p-3">
        Acabamos de enviar um e-mail contendo o link para recuperação da sua conta.
        Por favor, verifique a sua caixa de entrada e siga as instruções para completar o processo de recuperação.
        Se não encontrar o e-mail na sua caixa de entrada, por favor, verifique a pasta de spam.
      </p>

      <Message v-else-if="statusResponse > 299" class="mt-10" type="warn">
        Erro desconhecido. {{ statusResponse }}
      </Message>

      <Button
        v-if="statusResponse !== 200"
        name="button-recovery-email"
        class="bg-secondary-500 mt-5"
        @click="onSend"
        :is-loading="isLoading"
        loading-size="md"
        is-width-full
      >
        Solicitar
      </Button>

      <p class="mt-5 text-center text-lg text-white">
        <a href="/login" class="font-semibold hover:text-second"><b>Clique aqui para entrar</b></a>
      </p>

    </template>
  </TemplateBackground>
</template>

<script lang="ts" setup>

const statusResponse = ref(-1);
const isLoading = ref(false);
const isValideAll = ref(false);
const formData = reactive({ email: "" });
const formDataValidate = reactive({ email: true });
const api = useApi();

function onSend(){
  isValideAll.value = true;

  if (!validateFormData(formDataValidate)) return;

  isLoading.value = true;

  api.post("/user/send-recovery", formData)
    .then(res => {
      statusResponse.value = res.status;
    })
    .catch((err) => {
      statusResponse.value = err?.response?.status ?? 0;
      isLoading.value = false;
    });
}

useHead({ title: "Recuperação de senha" });

</script>